import { render, staticRenderFns } from "./dhmMsg.vue?vue&type=template&id=c0039fa6&scoped=true"
import script from "./dhmMsg.vue?vue&type=script&lang=js"
export * from "./dhmMsg.vue?vue&type=script&lang=js"
import style0 from "./dhmMsg.vue?vue&type=style&index=0&id=c0039fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0039fa6",
  null
  
)

export default component.exports